import React, {useEffect} from 'react';
import {shallowEqual, useDispatch, useSelector} from "react-redux";

import * as lineActions from '../../../_redux/orderlines/orderlinesActions';
import BootstrapTable from "react-bootstrap-table-next";
import {NoRecordsFoundMessage, PleaseWaitMessage} from "../../../../../../_metronic/_helpers";
import * as formatters from './column-formatters';

export function CardTable({setShowDialog}) {
    const { user } = useSelector((state) => state.auth);
    const {lastOrder, orderlines, orderLoading} = useSelector(
        (state) => ({
            orderlines: state.orderlines.entities,
            lastOrder: state.orders.lastOrder,
            orderLoading: state.orders.actionsLoading
        }),
        shallowEqual
    );

    const dispatch = useDispatch();

    const onDeleteClick = (id) => {
        dispatch(lineActions.deleteOrderline(id));
    }


    useEffect(() => {
        if (lastOrder) {
            dispatch(lineActions.getOrderlines(lastOrder.id));
        }
    }, [lastOrder, dispatch])

    useEffect(() => {
        console.log(user)
    }, [user]);


    const columns = [
        {
            dataField: "productName",
            text: "نام محصول",
        },
        {
            dataField: "qty",
            text: "مقدار درخواستی"
        },
        {
            dataField: "qtyFinal",
            text: "مقدار ثبت شده در سیستم",
        },
        {
            dataField: "totalPrice",
            text: "مبلغ کل",
            formatter: formatters.PriceColumnFormatter,
        },
        {
            dataField: "actions",
            text: "عملیات",
            formatter: formatters.ActionsColumnFormatter,
            formatExtraData: {
                onDeleteClick: onDeleteClick
            }
        }
    ]


    return (

        <>

            {orderlines && orderlines.length > 0 ? (
                <>
                    <BootstrapTable
                        wrapperClasses={"table-responsive"}
                        classes={"table table-head-custom table-vertical-center overflow-hidden"}
                        bootstrap4
                        bordered={false}
                        remote
                        keyField={"id"}
                        data={orderlines === null ? [] : orderlines}
                        columns={columns}
                    >
                        <PleaseWaitMessage entities={orderlines}/>
                        <NoRecordsFoundMessage entities={orderlines}/>
                    </BootstrapTable>


                </>
            ) : (
                <p>در حال حاضر هیچ آیتمی در سبد شما وجود ندارد.</p>
            )}
        </>
    )


}